import { render, staticRenderFns } from "./report-ipipm.vue?vue&type=template&id=7a16ecf0&scoped=true&"
import script from "./report-ipipm.vue?vue&type=script&lang=ts&"
export * from "./report-ipipm.vue?vue&type=script&lang=ts&"
import style0 from "./report-ipipm.vue?vue&type=style&index=0&id=7a16ecf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a16ecf0",
  null
  
)

export default component.exports